/** Balances are counted in half days: 17 reads "8½", 4 reads "2". */
export function formatHalfDays(halfDays: number): string {
  const whole = Math.trunc(halfDays / 2);
  const half = halfDays % 2 !== 0;
  if (!half) return String(whole);
  return `${whole === 0 ? (halfDays < 0 ? "-" : "") : whole}½`;
}
